import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { withRouterPath, InjectedProps as WithRouterPathProps } from 'platform-components/hocs';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose, Dispatch } from 'redux';

import LessonLoader from 'common.components/lesson-loader/lesson-loader';
import * as lessonViewActions from 'common.components/lesson-view.store/actions';
import * as lessonSelectors from 'common.components/lesson/selectors';
import NoLessonsPane from 'common.components/no-lessons-pane/no-lessons-pane';
import { actions as coursesActions } from 'store/courses/actions';

import { ReduxTeacherStore, RootAction } from '../../../typings';
import * as actions from '../actions';
import * as selectors from '../selectors';

type StoreProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;

interface OwnProps {
    courseId: number | null;
    shouldRenderEmptyMessage?: boolean;
}

interface DraftsLoaderProps extends WithRouterPathProps, OwnProps, StoreProps, DispatchProps {}

export class DraftsLoader extends React.Component<DraftsLoaderProps> {
    loadLessons = () => {
        const { courseId, getLessonsRequest, getLessonsCountRequest } = this.props;

        if (courseId) {
            getLessonsRequest(courseId, null);
            getLessonsCountRequest({ courseId });
        }
    };

    handleLessonClick = () => {
        const { toggleLessonModal } = this.props;

        toggleLessonModal(true);
    };

    checkShouldDisableLesson = (cLessonId: number) => {
        const { deletingLessonId } = this.props;

        return cLessonId === deletingLessonId;
    };

    render() {
        const { courseId, loadingStatus, shouldLoadLessons, lessons, shouldRenderEmptyMessage } = this.props;
        const shoudShowNoLessonsPane =
            loadingStatus === LOADING_STATUSES.SUCCESS && lessons.length === 0 && shouldRenderEmptyMessage;

        if (!courseId) {
            return null;
        }

        return (
            <>
                {shoudShowNoLessonsPane && <NoLessonsPane titleId="courseView.lessonsDrafts.noLessonsPane.text" />}
                <LessonLoader
                    canEditLessons={true}
                    checkShouldDisableLesson={this.checkShouldDisableLesson}
                    courseId={courseId}
                    getNextPageRequest={this.loadLessons}
                    lessons={lessons}
                    loadingStatus={loadingStatus}
                    onLessonClick={this.handleLessonClick}
                    shouldLoadLessons={shouldLoadLessons}
                    shouldShowLikes={false}
                />
            </>
        );
    }
}

const mapStateToProps = (storeState: ReduxTeacherStore, ownProps: OwnProps) => {
    const { courseId } = ownProps;

    return {
        deletingLessonId: lessonSelectors.getDeletingCLessonId(storeState),
        loadingStatus: selectors.getDraftsLoadingStatus(storeState, { courseId }),
        shouldLoadLessons: selectors.getShouldLoadMoreDrafts(storeState, { courseId }),
        lessons: selectors.getDrafts(storeState, { courseId }),
    };
};

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => {
    const { getDraftsRequest, clearLessons } = actions;
    const { getLessonsCountRequest } = coursesActions;
    const { toggleModal } = lessonViewActions;

    return bindActionCreators(
        {
            getLessonsRequest: getDraftsRequest,
            clearLessons,
            getLessonsCountRequest,
            toggleLessonModal: toggleModal,
        },
        dispatch
    );
};

export default compose<any>(withRouterPath, connect(mapStateToProps, mapDispatchToProps))(DraftsLoader);
